<template>
    <v-navigation-drawer
        v-model="Sidebar_drawer"
        :dark="SidebarColor !== 'white'"
        :color="SidebarColor"
        mobile-breakpoint="960"
        clipped
        :right="$vuetify.rtl"
        mini-variant-width="70"
        :expand-on-hover="expandOnHover"
        app
        id="main-sidebar"
        v-bar
    >
        <!---USer Area -->
        <v-list-item two-line class="profile-bg">
            <v-list-item-avatar>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-img v-bind="attrs" v-on="on" :src="($page.props.user) ? $page.props.user.profile_photo_url : ''" width="100%"></v-img>
                    </template>
                    <span>{{ ($page.props.user) ? $page.props.user.name : '' }}</span>
                </v-tooltip>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>{{ ($page.props.user) ? $page.props.user.name : '' }}</v-list-item-title>
                <v-list-item-subtitle class="caption">{{ ($page.props.user) ? $page.props.user.email : '' }}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <!---USer Area -->

        <v-list expand nav class="mt-1">
            <!---Sidebar Items -->
            <template v-for="(item, i) in items">
                <!---If Sidebar Caption -->
                <v-row v-if="item.header && hasaccess('header', item)" :key="item.header" align="center">
                <v-col cols="12">
                    <v-subheader v-if="item.header" class="d-block text-truncate">
                        {{ item.header }}
                    </v-subheader>
                </v-col>
                </v-row>
                <!-- -If Sidebar Caption -->
                <BaseItemGroup
                v-else-if="item.children && hasaccess('child', item)"
                class="icon-size"
                :key="`group-${i}`"
                :item="item"
                ></BaseItemGroup>
                <BaseItem v-else-if="hasaccess('child', item)" :key="`item-${i}`" :item="item" />
            </template>
            <!---Sidebar Items -->
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import MenuItems from "./MenuItems";
import BaseItemGroup from '@/components/BaseItemGroup.vue'
import BaseItem from '@/components/BaseItem.vue'

export default {
    name: "VerticalSidebar",
    components: {
        BaseItemGroup,
        BaseItem,
    },

    props: {
        expandOnHover: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            items: MenuItems,
        }
    },

    mounted() {
    },

    computed: {
        ...mapState(["SidebarColor", "SidebarBg"]),
        Sidebar_drawer: {
            get() {
            return this.$store.state.Sidebar_drawer;
            },
            set(val) {
            this.$store.commit("SET_SIDEBAR_DRAWER", val);
            },
        },
    },

    watch: {
        "$vuetify.breakpoint.smAndDown"(val) {
            this.$emit("update:expandOnHover", !val);
        },
    },

    methods: {
        hasaccess(pType, pItem) {
            if ((pType === 'header') && (this.$page.props.user)) {
                if (pItem.grantaccess.length > 0) {
                    return pItem.grantaccess.includes("all", 0) || pItem.grantaccess.includes(this.$page.props.user.usertype, 0)
                }
            }

            if ((pType === 'child') && (this.$page.props.user)) {
                if (pItem.grantaccess.length > 0) {
                    return pItem.grantaccess.includes("all", 0) || pItem.grantaccess.includes(this.$page.props.user.usertype, 0)
                }
            }
            return false
        }
    },
};
</script>

<style lang="scss">
#main-sidebar {
  box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
  -webkit-box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
  .v-navigation-drawer__border {
    display: none;
  }
  .v-list {
    padding: 8px 15px;
  }
  .v-list-item {
    min-height: 35px;
    &__icon--text,
    &__icon:first-child {
      justify-content: center;
      text-align: center;
      width: 20px;
    }
  }
  .v-list-item__icon i {
    width: 20px;
  }
  .icon-size .v-list-group__items i {
    width: 16px;
    font-size: 16px;
  }
  .profile-bg {
    &.theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
      opacity: 1;
    }
    .v-avatar {
      padding: 15px 0;
    }
  }
  .theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
  }
}
</style>
